// Mock data for Just'Une Dalle Food Truck

export const foodTruckInfo = {
  name: "Just'Une Dalle",
  slogan: "L'accueil qui fait autant plaisir que la commande.",
  phone: "07 68 50 94 37",
  address: "429 Route de Bourg, 01340 Malafretaz",
  email: "contact@justunedalle.fr",
  social: {
    instagram: "https://instagram.com/justunedalle",
    facebook: "https://facebook.com/justunedalle"
  }
};

export const badges = [
  { icon: "Star", text: "5/5 — Clients satisfaits", color: "yellow" },
  { icon: "Heart", text: "Portions généreuses", color: "yellow" },
  { icon: "Flame", text: "Street-food gourmande", color: "red" },
  { icon: "MapPin", text: "À Malafretaz (01340)", color: "white" }
];

export const schedule = [
  { day: "Dimanche", hours: "18h00–21h30", open: true },
  { day: "Lundi", hours: "18h00–21h30", open: true },
  { day: "Mardi", hours: "18h00–21h30", open: true },
  { day: "Mercredi", hours: "Fermé", open: false },
  { day: "Jeudi", hours: "Fermé", open: false },
  { day: "Vendredi", hours: "18h00–22h00", open: true },
  { day: "Samedi", hours: "18h00–22h00", open: true }
];

export const featuredDishes = [
  {
    id: 1,
    name: "Tacos Steak Fromage",
    description: "Généreux tacos garni de steak haché, sauce fromagère onctueuse et crudités fraîches.",
    image: "https://images.pexels.com/photos/8448320/pexels-photo-8448320.jpeg",
    price: "8,50 €"
  },
  {
    id: 2,
    name: "Burger Double Smash Maison",
    description: "Double steak smashé, cheddar fondant, oignons caramélisés et sauce maison.",
    image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd",
    price: "9,90 €"
  },
  {
    id: 3,
    name: "Américain Poulet Croustillant",
    description: "Poulet pané croustillant, salade, tomates, sauce américaine dans un pain brioché.",
    image: "https://images.unsplash.com/photo-1586190848861-99aa4a171e90",
    price: "7,50 €"
  }
];

export const menuCategories = [
  {
    name: "Tacos",
    icon: "UtensilsCrossed",
    items: [
      { name: "Tacos Steak", price: "8,50 €", description: "Steak haché, sauce fromagère, crudités" },
      { name: "Tacos Tenders", price: "8,50 €", description: "Poulet tenders croustillant, sauce au choix" },
      { name: "Tacos Merguez", price: "8,50 €", description: "Merguez grillée, sauce harissa douce" },
      { name: "Tacos Mix 2 Viandes", price: "9,50 €", description: "Choix de 2 viandes, double garniture" },
      { name: "Formule Tacos + Frites + Boisson", price: "12,90 €", description: "Menu complet au choix", featured: true }
    ]
  },
  {
    name: "Burgers & Américains",
    icon: "Sandwich",
    items: [
      { name: "Burger Classic", price: "7,90 €", description: "Steak, salade, tomate, oignons, sauce burger" },
      { name: "Double Smash Burger", price: "9,90 €", description: "Double smash, cheddar, oignons caramélisés", featured: true },
      { name: "Américain Poulet", price: "7,50 €", description: "Poulet pané, crudités, sauce américaine" },
      { name: "Américain Steak", price: "7,50 €", description: "Steak haché, crudités, sauce américaine" }
    ]
  },
  {
    name: "Hot-dogs",
    icon: "Utensils",
    items: [
      { name: "Hot-dog Classique", price: "4,50 €", description: "Saucisse, moutarde, ketchup" },
      { name: "Hot-dog Fromage", price: "5,00 €", description: "Saucisse, sauce cheddar, oignons" }
    ]
  },
  {
    name: "Crêpes",
    icon: "Cookie",
    items: [
      { name: "Crêpe Nutella", price: "3,00 €", description: "Crêpe maison au Nutella" },
      { name: "Crêpe Confiture", price: "3,00 €", description: "Crêpe maison confiture au choix" }
    ]
  },
  {
    name: "Frites & Sides",
    icon: "FrenchFries",
    items: [
      { name: "Frites Maison", price: "3,50 €", description: "Frites fraîches et croustillantes" },
      { name: "Sauce Fromagère", price: "1,00 €", description: "Supplément sauce cheddar" }
    ]
  },
  {
    name: "Boissons",
    icon: "Coffee",
    items: [
      { name: "Eau", price: "1,00 €", description: "Bouteille 50cl" },
      { name: "Soda", price: "2,00 €", description: "Coca, Fanta, Sprite, Oasis" },
      { name: "Café", price: "1,50 €", description: "Café expresso" }
    ]
  }
];

export const reviews = [
  {
    id: 1,
    author: "Gregory",
    rating: 5,
    text: "Un vrai régal. Les portions sont généreuses et l'accueil super chaleureux. Je recommande vivement !",
    date: "Il y a 2 semaines"
  },
  {
    id: 2,
    author: "Delphine",
    rating: 5,
    text: "Les tacos excellents et généreux, parfait ! On reviendra c'est sûr.",
    date: "Il y a 1 mois"
  },
  {
    id: 3,
    author: "Laure",
    rating: 5,
    text: "INCROYABLE. Un régal ! Portions généreuses, équipe top. Le meilleur food truck de la région.",
    date: "Il y a 3 semaines"
  },
  {
    id: 4,
    author: "Pont Olivier",
    rating: 5,
    text: "Magnifique ! Une régalade ! Les burgers sont excellents et le service impeccable.",
    date: "Il y a 1 mois"
  },
  {
    id: 5,
    author: "Davy",
    rating: 5,
    text: "Un truck de dingue, super bien garni, équilibré en goût. Le double smash burger est une tuerie !",
    date: "Il y a 2 semaines"
  },
  {
    id: 6,
    author: "Marie-Claire",
    rating: 5,
    text: "Première visite et certainement pas la dernière ! Tacos au top, frites croustillantes. Parfait.",
    date: "Il y a 1 semaine"
  },
  {
    id: 7,
    author: "Thomas",
    rating: 5,
    text: "Enfin un vrai food truck street-food dans le coin ! Qualité au rendez-vous, je suis fan.",
    date: "Il y a 3 semaines"
  },
  {
    id: 8,
    author: "Sophie",
    rating: 5,
    text: "Accueil au top, produits frais, portions XXL. Que demander de plus ? Foncez !",
    date: "Il y a 2 semaines"
  }
];

export const aboutContent = {
  title: "Un food truck qui régale autant par le goût que par l'accueil.",
  paragraphs: [
    "Just'Une Dalle, c'est l'histoire d'une passion pour la street-food authentique et généreuse. Installés à Malafretaz depuis notre lancement, nous avons à cœur de proposer une cuisine de qualité, préparée avec des produits frais et beaucoup d'amour.",
    "Notre philosophie ? Des portions généreuses, des recettes gourmandes et un accueil chaleureux qui fait la différence. Chaque burger, chaque tacos est préparé sur commande pour vous garantir fraîcheur et saveur.",
    "Que vous soyez amateur de burgers smashés, de tacos bien garnis ou de crêpes maison, vous trouverez votre bonheur chez Just'Une Dalle. Venez nous rendre visite et découvrez pourquoi nos clients reviennent encore et encore !"
  ],
  values: [
    { icon: "Leaf", title: "Produits Frais", description: "Ingrédients sélectionnés avec soin chaque jour" },
    { icon: "Heart", title: "Accueil Chaleureux", description: "Un sourire et une bonne humeur garantis" },
    { icon: "Scale", title: "Portions Généreuses", description: "Parce qu'on sait que vous avez faim" },
    { icon: "Award", title: "Qualité Maison", description: "Recettes élaborées avec passion" }
  ]
};

export const images = {
  hero: "https://images.unsplash.com/photo-1603088549155-6ae9395b928f",
  foodTruck: "https://images.unsplash.com/photo-1552912470-ee2e96439539",
  burger1: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd",
  burger2: "https://images.unsplash.com/photo-1572802419224-296b0aeee0d9",
  burger3: "https://images.pexels.com/photos/2271107/pexels-photo-2271107.jpeg",
  tacos1: "https://images.pexels.com/photos/8448320/pexels-photo-8448320.jpeg",
  tacos2: "https://images.unsplash.com/photo-1624300629298-e9de39c13be5",
  tacos3: "https://images.unsplash.com/photo-1599974579688-8dbdd335c77f"
};
